import { UPDATE_APP_DATA } from 'constants/action_types'
import { selectCurrentTotalPerCycle } from 'ducks/billing/selectors'
import {
  SHOPIFY_BILLING_CONFIRMED,
  UPDATE_SUBSCRIPTION_SUCCESS,
} from 'ducks/billing/types'
import { FETCH_CURRENT_USER_SUCCESS } from 'ducks/currentUser/types'
import { createActionTypeReducer } from 'util/reducers'
import { dataLayer } from 'util/tracking'
import { capture, record } from 'ducks/tracking/actions'
import { debounce } from 'util/functions'

const identifyUser = (_, { data: { currentUser: user } }) => {
  dataLayer({ event: 'identifyUser', userId: user.id })
}

const updateAppDataReducer = (state, action) => {
  identifyUser(state, action)
  if (action?.data?.billing?.inbox?.state === 'trial') {
    record()
  }
}

const trackConversion = (_, __, sharedState) => {
  const total = selectCurrentTotalPerCycle(sharedState)
  const account = sharedState.app.account
  const first = !account?.preferences?.usage_onboarding?.activated_subscription
  dataLayer({
    event: 'billingChange',
    accountId: account?.id,
    externalAccountId: sharedState.billing.externalAccountId,
    provider: sharedState.billing.provider,
    billingCycle: sharedState.billing.billing_cycle,
    total,
    isFirstConversion: first,
  })
  capture(`billing subscription update`, {
    external_account_id: sharedState.billing.externalAccountId,
    provider: sharedState.billing.provider,
    billing_cycle: sharedState.billing.billing_cycle,
    total,
    is_first_conversion: first,
  })
}

// Kevin R: 2023-08-23
// Debouncing here prevents siguations where we capture multiple pages views
// for the same page caused by certian loading functions modifying the query
// string while the page loads up. Its not a perfect solution, but it'll work
// good enough
const debouncedCapture = debounce(capture, 1000)

const trackPageView = (_, action) => {
  if (action.type.startsWith('onboarding/') && action.type.endsWith('_PAGE')) {
    debouncedCapture('$pageview')
  }
}

export default createActionTypeReducer(
  {
    [UPDATE_APP_DATA]: updateAppDataReducer,
    [FETCH_CURRENT_USER_SUCCESS]: identifyUser,
    [SHOPIFY_BILLING_CONFIRMED]: trackConversion,
    [UPDATE_SUBSCRIPTION_SUCCESS]: (draftState, payload, sharedState) => {
      // NOTE (jscheel): Shopify fires this action, but we don't actually know
      // that the customer has successfully set up a new subscription yet,
      if (sharedState.billing.provider === 'shopify') return draftState
      return trackConversion(draftState, payload, sharedState)
    },
    '*': trackPageView,
  },
  {}
)
